module.exports = __webpack_public_path__ + "img/5355973.jpg";